export class SupportIssue {
    id: number;
    creatingUserId: number;
    createdDate: Date;
    issueDate: Date;
    reportNumber: number;
    resolvingUserId: number;
    resolvedDate: Date;
    description: string;
    notes: SupportIssueNote[];
    status: SupportIssueStatus;
    applicantName: string;
    locationName: string;
    screeningId: number;
    creatingUserName: string;
    issueNoteCount: number;
    supportIssueTypeId : number;
    issueType : SupportIssueType;
    assignedTo: number;
    defectId: number;
    defectName: string;
    assignedUserName: string;
    issueSeverity: number;
    expectedResolution: string;
    reportedByUserId: number;
    issueSeverityPretty: string;
    issueStatusPretty: string;
    affectedReportOutcome: boolean;
}
    
export class SupportIssueNote {
    noteText: string;
    creatingUser: number;
    createdDate: Date;
    issueId: number;
    creatingUserName: string;
}

export enum SupportIssueStatus { 
    Open = 10,
    Verified = 15,
    NotVerified = 16,
    Working = 20,
    PendingManagerReview = 25,
    Resolved = 30,
    Cancelled = 40
}

export enum SupportIssueSeverity { 
    Low = 10,
    Medium = 20,
    High = 30,
    Critical = 40
}

export class SupportIssueDefect {
    id: number;
    defectName: string;
    supportIssueTypeId: number;
}

export interface SupportIssueType {
    id: number;
    issueName: string;
    /**the hex code for whatever color is used on the FE. */
    issueColor: string;
}

export class SupportIssueFilter {
    severity: number;
    assignedTo: number | null;
    status: number;
    defectTypeId: number;
    startDate: Date;
    endDate: Date;
}